
export default function designation( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_DESIGNATION':
			return action.designation
		case 'GET_DESIGNATION':
			return action.designation
		case 'DELETE_DESIGNATION':
			return action.designation
		case 'GET_BY_ID_DESIGNATION':
			return action.designation
		case 'EDIT_DESIGNATION':
			return action.designation
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/designation/designation.reducer.js